

namespace PaperTrail.NewsletterControl {
    @Serenity.Decorators.registerEditor('PaperTrail.NewsletterControl.NewsletterPageTemplateEditor')
    export class NewsletterPageTemplateEditor extends Serenity.Extensions.GridEditorBase<NewsletterPageTemplateRow> {
        protected getColumnsKey() { return NewsletterPageTemplateColumns.columnsKey; }
        protected getDialogType() { return NewsletterPageTemplateEditorDialog; }
        protected getLocalTextPrefix() { return NewsletterPageTemplateRow.localTextPrefix; }

        constructor(container: JQuery) { 
            super(container);

        }

        protected getAddButtonCaption() {
            return "Add Template ";
        } 

        validateEntity(row, id) {
            debugger;
            row.PageTemplateId = Q.toId(row.PageTemplateId);

            //we allow duplicate templates
            //var sameTemplate = Q.tryFirst(this.view.getItems(), x => x.Title === row.PageTemplateId);
            //if (sameTemplate && this.id(sameTemplate) !== id) {
            //    Q.alert('This template is already in order details!');
            //    return false;
            //}

            //row.PageTemplateTitle = NewsletterControl.NewsletterPageTemplateRow.getLookup().itemById[row.PageTemplateId].PageTemplateTitle; 
            return true;
        }

        public changeme() {

        }


        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);
            
            buttons.push({
                title: "Pick Templates",
                cssClass: "add-button",
                icon: "fa-plus-circle text-green",
                onClick: () => {
                    var dlg = new PageTemplatePickerDialog({
                        //we allow dup templates
                        //hideTemplates: this.view.getItems().map(x => x.PageTemplateId)
                    });
                    dlg.onSuccess = (selected) => {
                        // filter already existing products ** we allow dup templates
                        //selected = selected.filter(x => !Q.any(this.view.getItems(), y => y.PageTemplateId == x.PageTemplateId));
                        debugger;
                        for (var sel of selected) {
                            var item = <NewsletterPageTemplateRow>{
                                PageTemplateId: sel.PageTemplateId,
                                Rank: this.view.getItems().length + 1,
                                PageTemplateTitle: sel.Title,
                                //TemplateSections: sel.TemplateSections,
                                PageTemplateFileName: sel.FileName,
                                PageTemplateAdsSpots: sel.AdsSpots,
                                PageTemplateNewsSpots: sel.NewsSpots,
                                PageTemplateRank: sel.Rank
                            };
                            //sel.Rank = this.view.getItems().length + 1;
                            var id = this.getNextId();
                            item[this.getIdProperty()] = id;
                            this.view.addItem(item);
                        }

                        return true;
                    };
                    dlg.dialogOpen();
                }
            });
            return buttons;
        }

        private _templateID: number;
        get templateID() {
            return this._templateID;
        }

        set templateID(value: number) {
            if (value !== this._templateID) {
                this._templateID = value;
                this.refresh();
            }
        }
    }
}